var render = function render(){var _vm=this,_c=_vm._self._c;return _c('textarea',{staticClass:"textarea has-margin-bottom",class:{ 'is-borderless' : _vm.inputBorderless },domProps:{"value":_vm.value},on:{"blur":(e) => { _vm.stripHtml(e), _vm.onBlur(e) },"focus":_vm.stripHtml,"input":_vm.onInput}})
}
var staticRenderFns = []

export { render, staticRenderFns }